import './popin-validate.component.ajscss';

import { IComponentController, IComponentOptions } from 'angular';
import { i18n } from 'i18next';

import { PopinValidateParam } from './models/popin-validate-param';
import templateUrl from './popin-validate.component.html';

class PopinValidateCtrl implements IComponentController {
  close: Function;
  dismiss: Function;
  resolve: Function;

  private confirm: Function;
  private title: string;
  private message: string;

  constructor(private readonly $i18next: i18n) {}

  $onInit(): void {
    const container = document.getElementById('title-popup-validate');
    if (container) {
      container.focus();
    }
    let param: PopinValidateParam = this.resolve();
    this.confirm = param.confirm;
    this.title = param.title;
    this.message = param.message;
  }

  valid(): void {
    this.confirm();
    this.cancel();
  }

  cancel(): void {
    this.dismiss();
  }

  titlePopup() {
    return this.$i18next.t(this.title);
  }

  messagePopup() {
    return this.$i18next.t(this.message);
  }
}

export class PopinValidate implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    close: '&',
    dismiss: '&',
    // custom
    resolve: '&',
  };
  controller = ['$i18next', PopinValidateCtrl];
}

export default 'popupValidate';
